import {
  HomeBanner1,
  HomeBanner2,
  ProductInfoImg1,
  ProductInfoImg2,
  ProductInfoImg3,
  ProductImg1,
  ProductImg2,
  ProductImg3,
  ProductImg4,
  formImg,
  LogoWhite,
  homeFormGift,
  HomeBanner3,
  HomeBanner4,
  VideoPoster2,
} from "./images";
import HomeVideo from "assets/home/video.mp4";
import HomeVideo2 from "assets/home/video2.mp4";
import { SoundOnIcon, SoundOffIcon } from "./images";

export const HomeConfig = {
  header: {
    img: HomeBanner1,
    logo: LogoWhite,
    title: "SKIN CAVIAR EYE LIFT",
    subtitle: "魚子美顏 緊俏美眼精華\n全新上市",
    link: "https://lihi1.com/G4V7r",
  },
  contentInfo: {
    poster: HomeBanner2,
    video: HomeVideo,
    title: "SKIN CAVIAR EYE LIFT",
    icon: { soundon: <SoundOnIcon />, soundoff: <SoundOffIcon /> },
    subtitle: "眼周360拉提緊俏​ 勾勒凝視之美",
    content: `研究發現，肌膚底層的「垂直支撐網絡」，與圍繞在其周圍的「肌脂層」，對於眼周肌膚至關重要，二者間相互且緊密的「傳訊機制」， 使雙眼完美拉提緊緻。\n
        ​身為眼部保養專家的La Prairie萊珀妮，在眼部保養上有最進階的科技以及最精細分工的選擇，2024年品牌經典「魚子美顏緊俏美眼精華」奢華升級，添加全新二種魚子珍稀成分，成就第一支精準強韌垂直支撐網絡的眼部精華，並激活肌底深處的肌脂層，賦活二者間的傳訊機制，讓眼周緊緻，眼神嬌俏，再現風華雙眸。`,
  },
  productInfo: {
    title: "SKIN CAVIAR EYE LIFT",
    subtitle: `雙重魚子珍稀成分 Ⅹ 傳奇經典成分​\n綜效相乘 雙眸無懼重力`,
    products: [
      {
        img: ProductInfoImg1,
        title: "魚子緊韌活萃\nCaviar Infinite",
        content:
          "集35年尖端魚子美顏科學的研究大成，La Prairie創造出至臻理想的專利魚子複合物 - 「Caviar Infinite 魚子緊韌活萃」，加上高機能活性成分，有助於強健眼周肌膚垂支撐力，激活肌底深處的肌脂層，活絡垂直支撐網絡與肌脂層的傳訊機制，展現眼周緊緻輪廓線條，綻放年輕精緻雙眸。",
      },
      {
        img: ProductInfoImg2,
        title: "魚子微米激萃\nCaviar Micro-Nutrient",
        content:
          "一顆融入300多種豐富營養活性，加乘魚子緊韌活萃的活性作用， 將活絡傳訊機制功效推升至巔峰，賦活「垂直支撐網絡」與「肌脂層」的緊密合作，使眼周肌膚緊緻拉提效果更顯著。",
      },
      {
        img: ProductInfoImg3,
        title: "獨家活源返齡精萃\nExclusive Cellular Complex",
        content:
          "為La Prairie傳奇經典成分，啟動肌底活源，賦予肌膚豐沛的生命力，同時提供豐沛能量，強化雙魚子成分的效能，啟動肌膚保護、新生、強化、賦活的正循環，使眼周肌膚重新恢復彈性與密度，返齡淬鍊，再現永恆凝視之美。",
      },
    ],
  },
  products: {
    title: "SKIN CAVIAR\nCOLLECTION",
    subtitle: "魚子美顏系列",
    ProductBanner1: HomeBanner4,
    ProductBanner2: HomeBanner3,
    products1: [
      {
        img: ProductImg1,
        // label: "眼部商品",
        // title: `魚子眼部保養專家​`,
        title: "魚子美顏眼露",
        price: "15ml / NT$ 5,200",
        link: "https://lihi2.com/4suGk",
      },
      {
        img: ProductImg2,
        // label: "眼部商品",
        // title: `魚子眼部保養專家`,
        title: "NEW\n魚子美顏緊俏美眼精華",
        price: "20ml / NT$ 18,150",
        link: "https://lihi2.com/fcruY",
      },
      {
        img: ProductImg3,
        // label: "眼部商品",
        // title: `魚子眼部保養專家​`,
        title: "​魚子美眼霜",
        price: "20ml / NT$13,850",
        link: "https://lihi2.com/8SJGC",
      },
    ],
    products2: [
      {
        img: ProductImg2,
        // label: "眼部商品",
        // title: `魚子眼部保養專家`,
        title: "NEW\n魚子美顏緊俏美眼精華",
        price: "20ml / NT$ 18,150",
        link: "https://lihi2.com/fcruY",
      },
      {
        img: ProductImg4,
        // label: "臉部商品",
        // title: `魚子臉部緊俏經典​​`,
        title: `黃鑽魚子緊俏拉提精華\n(#反重力精華)`,
        price: "50ml / NT$26,000",
        link: "https://lihi2.com/v1vlm",
      },
    ],
    // note: {
    //   title: "官網獨家禮遇",
    //   content: "訂購經典商品即享\n魚子奢華4件禮、精緻禮盒包裝與免運服務",
    // },
  },
  videoSection: {
    title: "彩妝大師 小凱老師\n極致奢華推薦",
    video: HomeVideo2,
    poster: VideoPoster2,
  },

  form: {
    title: "SKIN CAVIAR EYE LIFT",
    subtitle: "魚子美顏 緊俏美眼精華\n新品預約體驗",
    note: "緊緻塑顏  綻放青春和諧之美",
    img: formImg,
    contents: [
      [
        {
          key: "gender",
          // label: "*稱謂",
          type: "RADIO",
          validate: { required: true },
        },
      ],
      [
        {
          key: "lastName",
          label: "姓氏",
          type: "INPUT",
          validate: "input",
          placeholder: "*姓氏",
          validate: { required: true },
        },
        {
          key: "firstName",
          label: "名字",
          type: "INPUT",
          validate: "input",
          placeholder: "*名字",
          validate: { required: true },
        },
      ],
      [
        {
          key: "year",
          label: "年",
          type: "OPTIONS",
          validate: { required: true },
          placeholder: "*生日/年",
        },
        {
          key: "month",
          label: "月",
          type: "OPTIONS",
          validate: { required: true },
          placeholder: "月",
        },
        {
          key: "day",
          label: "日",
          validate: { required: true },
          type: "OPTIONS",
          placeholder: "日",
        },
      ],
      [
        {
          key: "phone",
          label: "手機",
          type: "INPUT",
          validate: { required: true },
          placeholder: "*手機",
          inputProps: { inputMode: "numeric", pattern: "[0-9]*" },
        },
      ],
      [
        {
          key: "phoneVerify",
          label: "手機驗證碼",
          type: "phone-verify",
          validate: { required: false },
          placeholder: "*手機驗證碼",
          inputProps: { inputMode: "numeric", pattern: "[0-9]*" },
          extends: { type: "phone-verify", helperText: "請驗證手機號碼" },
        },
      ],
      [
        {
          key: "email",
          label: "Email",
          type: "INPUT",
          validate: { required: false },
          placeholder: "E-mail",
        },
      ],
      [
        {
          key: "branch",
          label: "櫃點",
          type: "OPTIONS",
          validate: { required: true },
          placeholder: "*請選擇櫃點",
        },
      ],
    ],
    private: {
      key: "private",
      label: "我同意將此資料提供予La Prairie萊珀妮行銷處理與使用。",
      type: "CHECKBOX",
      validate: { required: true },
    },
    introduce: {
      unsubmit: (
        <>
          即日起至4月30日止，完成線上填單並致電指定專櫃完成預約，即可於約定時間至專櫃，出示LINE官方號提供之活動確認簡訊，享有專業肌膚諮詢，體驗「魚子美顏緊俏美眼精華」服務，並獲得「魚子奢華體驗禮」乙份。
          {/* <br />
          <br /> */}
          {/* <strong>新客限量專屬禮遇</strong>
          ，不限金額消費，另享「魚子奢華三件禮」乙份！, */}
          <img
            src={homeFormGift}
            alt="form gift card"
            style={{ width: "100%", marginTop: "3rem" }}
          />
        </>
      ),
      submited: "感謝您的參與，歡迎至官網探索更多「魚子美顏緊緻塑顏精萃」。",
    },
    link: "https://lihi1.com/dU9v0",
    notes: [
      "La Prairie致力於提供您奢華且安心的專屬服務，全體美容顧問皆嚴謹管理健康情形、每日定時量體溫、全程配戴口罩，並即時清潔消毒櫃檯環境。",
      "活動期間即日起至4/30止，每人限兌換乙份。數量有限兌完為止。LINE轉發、截圖無效。",
      "La Prairie保有最終活動解釋及調整權利。",
      "母親節預購會首四日恕不提供兌換。",
    ],
  },
};
